import { isNilOrEmpty } from "../language/module";
import { getResource } from "../language/resources/getResource";
import {
  isDateDifferenceGreaterThanOneYear,
  toDateOnly,
} from "../language/time";
import { EntitlementHotlistType } from "./hotlistReport/entitlementHotlistType";

export const validateHotlistReportParameters = (
  resources: Record<string, any>,
  hotlistType: EntitlementHotlistType | null,
  fromDate: Date | null,
  toDate: Date | null
): string | null => {
  if (hotlistType === null) {
    return getResource(resources, "REPORTS_HOTLIST_NO_REASON");
  }

  if (typeof hotlistType === "number" && hotlistType < 0) {
    return getResource(resources, "REPORTS_HOTLIST_NO_REASON");
  }

  return validateHotlistReportDates(resources, fromDate, toDate);
};

export const validateHotlistReportDates = (
  resources: Record<string, any>,
  fromDate: Date | null,
  toDate: Date | null
): string | null => {

  if (isNilOrEmpty(fromDate)) {
    return getResource(resources, "REPORTS_HOTLIST_INVALID_FROM_DATE");
  }

  if (isNilOrEmpty(toDate)) {
    return getResource(resources, "REPORTS_HOTLIST_INVALID_TO_DATE");
  }

  if (toDateOnly(fromDate!)! > toDateOnly(toDate!)!) {
    return getResource(resources, "REPORTS_HOTLIST_FROM_BEFORE_TO_DATE");
  }

  if (
    isDateDifferenceGreaterThanOneYear(
      toDateOnly(fromDate!)!,
      toDateOnly(toDate!)!
    )
  ) {
    return getResource(resources, "REPORTS_HOTLIST_DATE_RANGE_MAX");
  }

  return null;
};
